import React, { useCallback } from 'react';
import { AdminServiceEvents, BannerType, ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

type StoreBannerParamsType = Omit<Partial<BannerType>, 'start_date' | 'end_date'> & {
    start_date: string | Date;
    end_date: string | Date;
};
export const useStoreBanner = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const storeBanner = useCallback(
        async (id: undefined | number, params: StoreBannerParamsType) => {
            if (typeof params.start_date === 'object') {
                params.start_date = params.start_date.toISOString().split('T')[0];
            }
            if (typeof params.end_date === 'object') {
                params.end_date = params.end_date.toISOString().split('T')[0];
            }

            try {
                await services.api.call(
                    {
                        method: id ? 'put' : 'post',
                        url: `/api/banners${id ? `/${id}` : ''}`,
                        data: params,
                    },
                    { handledErrors: true }
                );
                services.events.publish(events.banner_list_updated);
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api, services.events, events.banner_list_updated]
    );

    return storeBanner;
};
